import firebase from 'firebase/app';
import * as config from "../constants"

const _config = {
    apiKey: config.FIREBASE_API_KEY,
    authDomain: config.FIREBASE_AUTH_DOMAIN,
    databaseURL: config.FIREBASE_DATABASE_URL,
    projectId: config.FIREBASE_PROJECTID,
    storageBucket: config.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.FIREBASE_MESSAGING_SENDERID,
    appId: config.FIREBASE_MESSAGING_APPID,
};

if (!firebase.apps.length) {
    firebase.initializeApp(_config);
}

// Initialize Cloud Firestore through Firebase
const db = firebase.firestore();
const settings = {};
db.settings(settings);

export {
    db,
};